import { z } from 'zod';

export const MaterialListScalarFieldEnumSchema = z.enum(['materialListId','cityId','typeMaterial','detailsMaterial','unitMaterial','unitCostMaterial','vendorMaterial','displayOrder','displayGroup','jobTypeLists','lastUpdated','updatedBy']);

export default MaterialListScalarFieldEnumSchema;
